<template>
  <div class="ai-solution-schools">
    <div>
      <Banner :sectionTitle="bannerDetails.sectionTitle" :sectionSubtitle="bannerDetails.sectionSubtitle"
        :imagePath="bannerDetails.imagePath" :mobileImagePath="bannerDetails.mobileImagePath"
        :buttonBool="bannerDetails.buttonBool" />
    </div>

    <!-- <TwoButtonsRow /> -->

    <div class="white-container">
      <div class="mb-5" v-for="(item, index) in sectionDetails" :key="index">
        <ImageText :sectionName="item.sectionName" :sectionTitle="item.sectionTitle"
          :sectionDescription="item.sectionDescription" :imagePath="item.imagePath" :imageLeft="item.imageLeft"
          v-if="index < 2">
        </ImageText>
      </div>
    </div>

    <a name="industrySolutions"></a>
    <div class="grey-container">
      <p class="middle-heading"> Solutions for Schools </p>

      <div class="mx-auto w-60">
        <p class="middle-subtitle">
          It takes more than just actively moving around to get students to be physically healthy. The holistic approach to Physical Education is in trend. EliteFit.AI can provide some relief for educators and focus on what is important.        </p>
      </div>

      <div v-for="(item, index) in sectionDetails" :key="index">
        <ImageText :sectionName="item.sectionName" :sectionTitle="item.sectionTitle"
          :sectionDescription="item.sectionDescription" :imagePath="item.imagePath" :imageLeft="item.imageLeft"
          v-if="index > 1">
        </ImageText>
        <div class="mb-5" v-if="index == 2"></div>
      </div>
    </div>

    <div class="empty-container">
    </div>
    <RequestDemo :includeModal="false" />
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import ImageText from "@/components/ImageText.vue";
import RequestDemo from "@/components/RequestDemo.vue"
import TwoButtonsRow from "@/components/TwoButtonsRow.vue"

import bannerImage from "@/assets/images/schools/school-headline.png";
import mobileBannerImage from "@/assets/images/schools/school-headline-mobile.png"
import image1 from "@/assets/images/schools/school-intro.png";
import image2 from "@/assets/images/schools/school-challange.png";
import image3 from "@/assets/images/schools/school-sol.png";
import image4 from "@/assets/images/schools/School_Privacy.png";



export default {
  data() {
    return {
      bannerDetails: {
        imagePath: bannerImage,
        mobileImagePath: mobileBannerImage,
        sectionTitle: "FROM DATA TO RESULTS",
        sectionSubtitle: "HOW AI IS HELPING SPORTS TEACHERS TO MAKE INFORMED DECISIONS AND ACHIEVE SUCCESS",
        buttonBool: true
      },
      sectionDetails: [
        {
          sectionName: "EliteFit.AI X Schools",
          sectionTitle: "Transforming physical education with the power of AI",
          sectionDescription: "Leverage AI to enhance students' physical health and form through customized fitness challenges, progress monitoring, pose detection, and live digital feedback. This will improve physical health and performance while reducing the risk of injury during workouts, thereby elevating overall physical fitness standards within the school community.",
          imagePath: image1,
          imageLeft: true,
        }, {
          sectionName: "Challenges with Tech",
          sectionTitle: "Questioning the efficacy of technology in physical education",
          sectionDescription: "School physical education teachers encounter challenges, such as insufficient time and resources to offer quality programs, inadequate student involvement, and the responsibility of ensuring safety and correct form. As schools face budget constraints, they are cautious about adopting trendy technology products that lack practical applications.",
          imagePath: image2,
          imageLeft: false,
        }, {
          sectionName: "All-in-one technology",
          sectionTitle: "More than just fitness gamification",
          sectionDescription: "EliteFit.AI offers over 1000 AI-powered workout videos with instant feedback and group challenges to ensure students are enjoying themselves while maintaining proper form either at home or at school. Additionally, our rep-counters are designed for rep-based workouts and our pose detection technology aids in reducing sports-related injuries. Physical educators can use the collected workout data to monitor progress, activity levels, and form.",
          imagePath: image3,
          imageLeft: true,
        },
        {
          sectionName: "Safety and Privacy",
          sectionTitle: "Students' data is safe",
          sectionDescription: "Ensuring the confidentiality of our users is our top priority and we adhere to transparent guidelines and industry-standard procedures when handling user data to comply with privacy regulations. To maintain the utmost privacy, we don't record any user videos and ensure that data is securely encrypted.",
          imagePath: image4,
          imageLeft: false,
        },
      ]
    };
  },
  components: {
    Banner,
    ImageText,
    RequestDemo,
    TwoButtonsRow
  },
};

</script>

<style lang="scss" scoped>
.white-container {
  padding-top: 10px;
}

.grey-container {
  padding-top:30px;
  background: #ECECEC;
}

.empty-container {
  height: 50px;
  background: #ECECEC;
}

.middle-heading {
  font-size: 3em;
  font-weight: bold;
  letter-spacing: 1px;
  color: #73bc44;
  text-align: center;
  padding-top: 40px;
}

.middle-subtitle {
  font-size: 1rem;
  letter-spacing: 1px;
  color: black;
  text-align: center;
  margin-bottom: 60px;
}
</style>